import { NG_VALIDATORS, Validator } from '@angular/forms';
import { forwardRef, Directive, Input } from '@angular/core';

export const requiredValidatorLogic = (required) => (control) => {
  if (!control.value) {
    return { valid: false };
  }

  return (control.value.id && control.value.id !== null) || (control.value.code && control.value.code !== null)
  || control.value.payScheduleID && control.value.payScheduleID !== null ?
    null : { valid: false };
};

const requiredValidator: any = {
  provide: NG_VALIDATORS,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => RequiredValidator),
  multi: true
};


@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[isRequired]',
  providers: [requiredValidator]
})

export class RequiredValidator implements Validator {
  @Input() public isRequired: boolean;
  public validator: any;
  constructor() {
    this.validator = requiredValidatorLogic(this.isRequired);
  }

  validate(c) {
    return this.validator(c);
  }
}

